export default "__VITE_ASSET__jMCcMn05__"